// extracted by mini-css-extract-plugin
export const sectionRoot = "F_bF";
export const btnPromote = "F_bG";